import React from "react";
import { Navigate, Route } from "react-router-dom";
import StudentDashboard from "../Modules/Student";
import StudentAssignment from "../Modules/Student/Screens/Assignments";
import StudentCourses from "../Modules/Student/Screens/Courses";
import MyProfile from "../Modules/Student/Screens/MyProfile";
import StudentCourseDetails from "../Modules/Practice/Screens/StudentCourseDetails";
import StudentQuestionListing from "../Modules/Practice/Screens/StudentQuestionListing";
import CompilerScreen from "../Modules/Practice/Screens/CompilerScreen";
import Practice from "../Modules/Practice";
import Assignments from "../Modules/Assignments/Screens/Assignments";
import AssignmentDetails from "../Modules/Assignments/Screens/AssignmentDetails";
import AssignmentTestScreen from "../Modules/Assignments/Screens/AssignmentTestScreen";
import AssignmentTestQuestion from "../Modules/Assignments/Screens/AssignmentTestQuestion";
import AssignmentSubmitSummary from "../Modules/Assignments/Screens/AssignmentSubmitSummary";
import AssignmentLeaderboard from "../Modules/Student/Screens/AssignmentLeaderboard";
import Contests from "../Modules/Student/Screens/Contests.jsx";
import Orders from "../Modules/Student/Screens/Orders";
import Task from "../Modules/Student/Screens/Task";
import DisplayTask from "../Modules/Student/Screens/DisplayTask";
import ModuleAssignmentDetails from "../Modules/Student/Screens/ModuleAssignmentDetails";
import Login3d from "../components/Login/Login3d.jsx";
import ModuleCompilerScreen from "../Modules/Student/Screens/ModuleCompilerScreen";
import OpeningUI from "../components/OpeningUI";
import LoginLoader from "../components/Login/LoginLoader.jsx";

const studentRoutes = [
  <Route key="dashboard" path="/dashboard" element={<StudentDashboard />} />,
  <Route key="student-contests" path="/student/contests" element={<Contests />} />,
  <Route
    key="assignment-leaderboard"
    path="/student/assignment-leaderboard"
    element={<AssignmentLeaderboard />}
  />,
  <Route
    key="assignment-leaderboard-details"
    path="/student/assignment-leaderboard/:assignmentId"
    element={<StudentAssignment />}
  />,
  <Route key="studentCourses" path="/student/courses" element={<Practice />} />,
  <Route
    key="my-profile"
    path="/student/my-profile"
    element={<MyProfile />}
  />,
  <Route key="student-orders" path="/student/orders" element={<Orders />} />,
  <Route
    key="practice-lab"
    path="/practice-lab"
    element={<Task />}
  />,
  <Route
    key="display-practice-lab"
    path="/practice-lab/display-practice-lab"
    element={<DisplayTask />}
  />,
  <Route
    key="module-assignment-details"
    path="/practice-lab/display-practice-lab/module-assignment-details"
    element={<ModuleAssignmentDetails />}
  />,
 
  <Route
    key="module-compiler-screen"
    path="/practice-lab/display-practice-lab/module-assignment-details/:clusterId/:courseId/:questionId"
    element={<ModuleCompilerScreen />}
  />,
  <Route key={"assignments"} path="/assignments" element={<Assignments />} />,
  <Route
    key="assignment-details"
    path="/assignments/:assignmentId"
    element={<AssignmentDetails />}
  />,
  <Route
    key="assignment-test-screen"
    path="/assignments/:assignmentId/test-screen"
    element={<AssignmentTestScreen />}
  />,
  <Route
    key="assignment-submit-summary"
    path="/assignments/:assignmentId/summary"
    element={<AssignmentSubmitSummary />}
  />,
  <Route
    key="assignment-test-question"
    path="/assignments/:assignmentId/test-screen/:questionId"
    element={<AssignmentTestQuestion />}
  />,
  <Route
    key="course-details"
    path="/student/courses/:clusterId"
    element={<Practice />}
  />,
  <Route
    key="course-details-specific"
    path="/student/courses/:clusterid/:courseId"
    element={<StudentCourseDetails />}
  />,
  <Route
    key="question-listing"
    path="/student/courses/:clusterid/:courseId/:categoryId"
    element={<StudentQuestionListing />}
  />,
  <Route
    key="compiler-screen"
    path="/student/courses/question/:clusterid/:courseId/:questionId"
    element={<CompilerScreen />}
  />,
];

export default studentRoutes;
